import { render, staticRenderFns } from "./NotApproved.vue?vue&type=template&id=009fa6a6&scoped=true&"
import script from "./NotApproved.vue?vue&type=script&lang=js&"
export * from "./NotApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009fa6a6",
  null
  
)

export default component.exports